module.exports = __webpack_public_path__ + "img/58_14.5454062d.png";